/**
 * Wrap any element in an anchor or insert an anchor right inside of any element
 * @modifier :inner {Boolean} true ? place <a> inside of element : place <a> around element
 * @modifier :new {Boolean} configure <a> to open in new tab
 * @example
 *   <span v-link.inner.new="my/path/i/care/about">{{ model.title }}</span>
 *   If modelBuilderPath is present then the span will turn into
 *     <span><a href="my/path/i/care/about" target="_blank">{{ model.title }}</a></span>
 *
 * @example
 *   <span v-link.inner.new="someVar">{{ model.title }}</span>
 *   If someVar is present then the span will turn into
 *     <span><a href="someVarValue" target="_blank">{{ model.title }}</a></span>
 *   If someVar is not present then the span will stay a span
 *     <span>{{ model.title }}</span>
 */
export default {
  inserted: function(el, binding, node) {
    let href: string
    if (typeof binding.value === 'string') {
      href = binding.value
    } else {
      href = binding.value?.href
    }
    if (href) {
      const target = binding.modifiers.new ? 'target="_blank"' : ''
      const linkHTML = `<a href="${href}" class="btn-link" ${target}></a>`
      const wrappingElementFunction = () => linkHTML
      if (binding.modifiers.inner) {
        $(el).wrapInner(wrappingElementFunction)
      } else {
        $(el).wrap(wrappingElementFunction)
      }
    }
  }
}